// Labels and formatting shared by the analytics panel and the person sheet.

export const LINK_LABELS = {
  share: 'Full gallery',
  branded: 'Branded',
  simple: 'Simple',
  find_me: 'Find Me',
  headshot: 'Headshot',
};

export const linkLabel = (link) => LINK_LABELS[link] || link;

export const viewerTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
};

/** What the visitor actually received, in words. */
export const deliveredSizeLabel = ({ size, served_from: servedFrom }) => {
  if (servedFrom === 'preview') return 'Preview size';
  if (size === 'social') return '2048px';
  if (size === 'full') return 'Full size';
  return null;
};

export const formatDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString('en-AU', { day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit' })
    : '—';

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const formatRelative = (iso) => {
  if (!iso) return '—';
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days}d ago`;
  return formatDate(iso);
};

export const initials = (name, email) => {
  const source = (name || email || '?').trim();
  const parts = source.split(/[\s.@_-]+/).filter(Boolean);
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?';
};

const csvCell = (value) => {
  const text = value === null || value === undefined ? '' : String(value);
  return /[",\n\r]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const peopleToCsv = (people) => {
  const header = [
    'Name', 'Email', 'Company domain', 'Links', 'Visits', 'Face searches', 'Found in photos', 'Match emails sent',
    'Match emails on',
    'Downloads', 'Branded downloads', 'Original downloads', 'Photos downloaded', 'ZIP requests',
    'First seen', 'Last seen',
  ];
  const rows = people.map((p) => [
    p.name, p.email, p.domain, p.links.map(linkLabel).join(' / '), p.visits, p.searches,
    p.photos_found, p.match_emails, p.subscribed ? 'Yes' : 'No', p.downloads, p.branded_downloads, p.original_downloads,
    p.photos_downloaded, p.zip_requests, p.first_seen, p.last_seen,
  ]);
  return [header, ...rows].map((row) => row.map(csvCell).join(',')).join('\r\n');
};

export const downloadTextFile = (filename, text, type = 'text/csv;charset=utf-8') => {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
